import React from 'react';
import Cookies from 'universal-cookie';
import ReactGA from "react-ga4";
import '../css/privacy.css';

export default function Privacy() {

    const handleClearStorage = () => {
        const cookies = new Cookies();
        cookies.remove('cookieConsent');
        cookies.remove('_ga_TT0D9NCLMY', { path: '/' });
        cookies.remove('_ga', { path: '/' });
        window[`ga-disable-G-TT0D9NCLMY`] = true;
        ReactGA.reset();
        window.location.reload(true);
    };

    return (
        <div className="privacyContainer">
            <div className="privacyTextMain">
                <h1>Pradžia</h1>
                <p>
                    Šiame puslapyje pateikiama informacija kaip FinansaiLab tinklapis naudoja jūsų informaciją, duomenis.<br />
                    Taip pat, čia yra tiksliai, paprastai ir aiškiai aprašyta kaip yra naudojami slapukai ir ką jie daro.
                </p>
                <h1>Registracija Konsultacijai</h1>
                <p>
                    Kai naudojatės registracija forma Konsultacijos tinklapyje, jūsų suvesti duomenys (vardas, pavardė,<br />
                    elektroninis paštas, telefono numeris, bet kokia informacija kurią įvesite žinutės laukelyje)<br />
                    bus išsiunčiama į mūsų oficialų elektroninį paštą, naudojant emailJs servisą.<br />
                    Ši informacija bus naudojama tik susisiekimui su jumis. Ši informacija nebus viešinama.
                </p>
                <h1>Registracija Konsultacijai</h1>
                <p>
                    Kai naudojatės registracija forma Karjera tinklapyje, jūsų suvesti duomenys (vardas, pavardė,<br />
                    elektroninis paštas, telefono numeris)<br />
                    bus išsiunčiama į mūsų oficialų elektroninį paštą, naudojant emailJs servisą.<br />
                    Ši informacija bus naudojama tik susisiekimui su jumis. Ši informacija nebus viešinama.
                </p>
                <h1>Slapukų Politika</h1>
                <p>
                    Šiame tinklapyje yra naudojami šie būtini slapukai (jų paskirtis ir naudojimo būdas šalia):<br />

                </p>
                <table>
                    <thead>
                        <tr>
                            <th>Cookie</th>
                            <th>Contact</th>
                        </tr></thead>
                    <tbody>
                        <tr>
                            <td>_ga</td>
                            <td>Naudojama vartotojams atskirti.</td>
                        </tr>
                        <tr>
                            <td>_ga_TT0D9NCLMY</td>
                            <td>Naudojama sesijos būsenai išlaikyti.</td>
                        </tr>
                        <tr>
                            <td>cookieConsent</td>
                            <td>Naudojama išsaugoti slapukų pasirinkimą.</td>
                        </tr>
                    </tbody>


                </table>
                <p>Slapukai su pradžia "_ga" naudojami Google Analytics platformai (ga4 cookies). Šie slapukai 
                    neveikia (nebesidalina informacija) nesutikus su privatumo politika, at atstačius ją. Apie tai
                    galite sužinoti
                    daugiau <a href="https://support.google.com/analytics/answer/11397207?hl=en" target="_blank" rel="noreferrer"> čia</a>.<br />
                    Slapukas "cookieConsent" yra būtinas, kad būtų išsaugotas jūsų pasirinkimas.
                </p>
                <button className='privacyButton' onClick={handleClearStorage}>Išvalyti saugyklą</button>
            </div>
        </div>
    )
}